// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import "element-ui/lib/theme-chalk/index.css"
import './element-variables.scss'
import './style/main.css';

// locale.el.pagination.total = "Total" + `{total}` + "Records";

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  console.log("path=", to.path, "accessToken=", window.localStorage.getItem('accessToken'));
  const tokenStr = window.localStorage.getItem('accessToken')
  const refreshTokenStr = window.localStorage.getItem("refreshToken")
  if (to.path === from.path) {
    next(false); // 阻止导航
  }
  if (tokenStr && refreshTokenStr) {
    if (to.path === '/') {
      next('/mainView')
    } else {
      next()
    }
  } else {
    if (to.path === '/login' || to.path === '/resetPassword' || to.path === '/resetInitialPassword' || to.path === '/register') {
    // if (to.path !== '/login') {
      next()
    } else {
      next('/login')
    }
  }


  // if (to.path === '/' && tokenStr && refreshTokenStr) { //登录状态
  //   return next('mainView')
  // } else if (to.path === '/login') {
  //   return next()
  // }
  // if (!tokenStr) {
  //   return next('/login')
  // }
  // next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js